import type { RegistryEntry } from '../types';

export const klingConfigs: Record<string, RegistryEntry> = {
    // Kling 2.6 Pro：支持同步音频 + CFG Scale
    'kling-v2.6': {
        options: [
            { key: 'sound', label: 'Audio', type: 'switch', default: false, group: 'basic' },
            { key: 'cfg_scale', label: 'CFG Scale', type: 'slider', min: 0, max: 1, step: 0.1, default: 0.5, group: 'advanced' },
        ],
        toProviderOptions: (ui) => ({
            sound: typeof ui.sound === 'boolean' ? ui.sound : false,
            cfg_scale: typeof ui.cfg_scale === 'number' ? ui.cfg_scale : 0.5,
        } as unknown as Record<string, Record<string, any>>),
    },
    // Kling 2.5 Turbo：无同步音频，仅 CFG Scale
    'kling-v2.5': {
        options: [
            { key: 'cfg_scale', label: 'CFG Scale', type: 'slider', min: 0, max: 1, step: 0.1, default: 0.5, group: 'advanced' },
        ],
        toProviderOptions: (ui) => ({
            cfg_scale: typeof ui.cfg_scale === 'number' ? ui.cfg_scale : 0.5,
        } as unknown as Record<string, Record<string, any>>),
    },
    // Kling V3 系列 (kling-v3.0 / omni / omni-multi 共享配置)
    ...Object.fromEntries(
        ['kling-v3.0', 'kling-v3.0-omni', 'kling-v3.0-omni-multi'].map(id => [id, {
            options: [
                { key: 'audio', label: 'Audio', type: 'switch', default: true, group: 'basic' },
                { key: 'watermark', label: 'Watermark', type: 'switch', default: false, group: 'basic' },
            ],
            toProviderOptions: (ui: Record<string, any>) => ({
                sound: typeof ui.audio === 'boolean' ? ui.audio : true,
                watermark: typeof ui.watermark === 'boolean' ? ui.watermark : false,
            } as unknown as Record<string, Record<string, any>>),
        } satisfies RegistryEntry])
    ),
    'kling-v3.0-omni-v2v': {
        options: [
            { key: 'keep_original_sound', label: 'Keep Original Sound', type: 'switch', default: true, group: 'basic' },
        ],
        toProviderOptions: (ui) => ({
            keep_original_sound: typeof ui.keep_original_sound === 'boolean' ? ui.keep_original_sound : true,
            watermark: typeof ui.watermark === 'boolean' ? ui.watermark : false,
        } as unknown as Record<string, Record<string, any>>),
    },
    'kling-2.6-motion-control': {
        options: [
            {
                key: 'character_orientation',
                label: 'Character Orientation',
                type: 'select',
                options: [
                    { label: 'Image', value: 'image' },
                    { label: 'Video', value: 'video' },
                ],
                default: 'image',
                group: 'basic',
            },
        ],
        toProviderOptions: (ui) => ({
            kie: {
                character_orientation: typeof ui.character_orientation === 'string' ? ui.character_orientation : 'image',
            },
        }),
    },
};
